/*
* Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
* SPDX-License-Identifier: MIT
*
* Licensed under the MIT License. See the LICENSE accompanying this file
* for the specific language governing permissions and limitations under
* the License.
*/

import { I18n } from '@aws-amplify/core';

export function translateFormErrorMessage(message) {
	if (!message) {
		return '';
	}
	const text = typeof message === 'string' ? message.trim() : String(message);
	return I18n.get(text);
}
